<template>
  <b-modal size="xl" centered  scrollable id="modal-sous-rubrique" ref="modal-sous-rubrique" title="Création d'une nouvelle sous-rubrique" @hidden="resetInput">
      <b-form>
        <b-form-group
            label='Libellé'
            label-for='libelle'
          >
          <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
          <span class="field-error">{{ errors.libelle }}</span>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="md"
            class="float-left"
            @click="resetInput; $bvModal.hide('modal-rubrique')"
          >
            Fermer
          </b-button>
          <b-button type="button" @click="save" size="md" variant="primary" class="float-right">
            <i class="fa fa-save"></i> Enregistrer
          </b-button>
        </div>
      </template>
    </b-modal>
</template>

<script>
  import {isEmpty} from "@/utils/fileHelper";

export default {
	components: {
	},
  data() {
    return {
      libelle: "",
      errors: {
        libelle: '',
      },
    }
  },
  created() {
  },
  methods: {
    save() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};

        dataPost.libelle = this.libelle;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/sous-rubrique", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Création avec succès",
              text: "La sous-rubrique a bien été créée",
              showConfirmButton: false,
              timer: 5000
            });
            this.$event.emit('refresh-sous-rubrique-document');
            this.resetInput();
            this.$refs['modal-sous-rubrique'].hide();
            this.$event.emit('refresh-after-new-sousRubrique', response.data.sousRubrique);
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text:
                "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    clearErrors() {
      this.errors.libelle = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      return valid;
    },
    resetInput() {
      this.libelle = '';
    },
  }
}
</script>
<style scoped>
</style>
